<template>
  <div class="main-page page-postone">
    <Menus :title="title" :home="true" />
    <div class="container-flex content-postone">
      <div class="article-box">
        <div class="detail">
          <h2 class="title">{{article.title}}</h2>
          <div class="content" v-html="article.detail">
          </div>
        </div>
      </div>
      <div class="intro-box" v-if="intro">
        <div class="content">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '../components/Menu'
import api from '../datas/js/api.js'
import { NOTICE } from '@/datas/constants/statistics.js'

export default {
  components: {
    Menus
  },
  data () {
    return {
      title: '',
      intro: '',
      article: 'article'
    }
  },
  async mounted () {
    const { id } = this.$route.params
    if (NOTICE[id]) {
      // 数据统计
      this.$root.getStatistics(NOTICE[id])
    }
    const item = await this.$get(api.post + id + `&machine_id=${this.$store.state.device.point.no}&platform=ZD`, this)
    this.article = item.result.data
    this.title = this.$route.query.title || this.article.title
  }
}
</script>

<style lang="stylus">
.page-postone
  position relative
  .content-postone
    display flex
    justify-content center
    padding 0.15rem 0.6rem 0.45rem 0.6rem
    .article-box
      width 12rem
      height 100%
      border-radius 0.08rem
      background #fff
      overflow-y scroll
      webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .detail
        padding 0.55rem
        .title
          font-size 0.42rem
          text-align center
          margin-bottom 0.8rem
        p
          margin 1em !important
    .intro-box
      width 3.3rem
      margin-left 0.3rem
      .content
        height 3.5rem
        background #fff
        border-radius 0.08rem
</style>
